import React, { useState } from "react";
import { toast } from "sonner";
import { renderShareCard } from "../lib/shareCard";
import { track } from "../lib/analytics";
import { Eyebrow } from "./Primitives";

export default function ShareArchetypeCard({ archetype, referralCode }) {
    const [busy, setBusy] = useState(null);

    const share = async (format) => {
        if (busy) return;
        setBusy(format);
        try {
            const blob = await renderShareCard({ archetype, referralCode, format });
            const file = new File([blob], `ever-after-${archetype.id}-${format}.png`, { type: "image/png" });
            if (navigator.canShare && navigator.canShare({ files: [file] })) {
                try {
                    await navigator.share({
                        files: [file],
                        title: "Ever After",
                        text: `My love archetype: ${archetype.name}. youreverafter.com/r/${referralCode}`,
                    });
                    track("archetype_shared", { format, method: "share_sheet" });
                    setBusy(null);
                    return;
                } catch (err) {
                    if (err?.name === "AbortError") { setBusy(null); return; }
                }
            }
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = file.name;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(() => URL.revokeObjectURL(url), 4000);
            track("archetype_shared", { format, method: "download" });
            toast.success("Card saved — post it anywhere");
        } catch {
            toast.error("Could not create your card. Please try again.");
        }
        setBusy(null);
    };

    return (
        <div className="border border-burgundy/20 bg-cream-soft p-6" data-testid="share-archetype-card">
            <Eyebrow>Share your archetype</Eyebrow>
            <p className="mt-2 font-display text-lg text-burgundy leading-snug">
                Post your card. Every friend who takes the assessment moves your city up.
            </p>
            <div className="mt-4 grid grid-cols-2 gap-2.5">
                <button
                    data-testid="share-card-story-btn"
                    onClick={() => share("story")}
                    disabled={!!busy}
                    className="bg-burgundy text-cream uppercase text-[10px] tracking-[0.2em] py-3.5 disabled:opacity-60"
                >
                    {busy === "story" ? "Creating…" : "Story · 9:16"}
                </button>
                <button
                    data-testid="share-card-feed-btn"
                    onClick={() => share("feed")}
                    disabled={!!busy}
                    className="border border-burgundy text-burgundy uppercase text-[10px] tracking-[0.2em] py-3.5 disabled:opacity-60"
                >
                    {busy === "feed" ? "Creating…" : "Feed · 4:5"}
                </button>
            </div>
        </div>
    );
}
